<template>
  <div>
    <h1 class="align-center">Add illustration</h1>
    <create-form :save="store"></create-form>
  </div>
</template>

<script>
import CreateForm from './Form';
import imageApi from './../../../../api/image';

export default {
  components: {
    'create-form': CreateForm,
  },
  methods: {
    store(form) {
      imageApi.store(form).then((image) => {
        toastr.success('Created successfully');

        setTimeout(() => {
          location.href = '/profile/portfolio';
        });
      });
    },
  },
};
</script>